module.exports = "/_next/static/images/0ea7e7b431303ac12138a9c942c050fe-nubank-outdoor-lg@1x.jpg.webp";